import { render } from "./ModalHistory.vue?vue&type=template&id=47a0c456"
import script from "./ModalHistory.vue?vue&type=script&lang=js"
export * from "./ModalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__